import type { Breadcrumb } from '../../types/capi/shared';

type Props = {
  breadcrumbs: Breadcrumb[];
};

const BreadcrumbItem = ({
  breadcrumb,
  includeSeparator
}: {
  breadcrumb: Breadcrumb;
  includeSeparator: boolean;
}) => {
  return (
    <li data-cy="breadcrumb" className="text-sm text-grey-hide">
      {includeSeparator ? <span className="px-3">•</span> : ''}
      <a href={breadcrumb.path}>{breadcrumb.label}</a>
    </li>
  );
};

const Breadcrumbs = ({ breadcrumbs }: Props) => {
  return (
    <nav>
      <ul className="flex">
        {breadcrumbs.map((breadcrumb, i) => (
          <BreadcrumbItem
            data-cy={`breadcrumb:${i}`}
            key={breadcrumb.path}
            breadcrumb={breadcrumb}
            includeSeparator={i > 0}
          />
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
